<template>
  <div class="vloader" v-if="isLoading">
    <div>
      <i class="fa fa-spinner fa-spin" style="font-size:24px"></i>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  computed: {
    isLoading: function () {
      return this.$store.getters.isLoading
    }
  }
}
</script>
<style lang="scss">
  .vloader {
    text-align: center;
  }
</style>
